// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2z3RT","right":"styles_right__2fzJb"};